import { gql } from '@apollo/client';

type wSuggestAddressesItemType = {
  BUILDING_NAME: null | string;
  BUILDING_NUMBER: null | string;
  SUB_BUILDING_NUMBER: null | string;
  STREET_NUMBER: null | string;
  ADDRESS_LINE_1: null | string;
  ADDRESS_LINE_2: null | string;
  ADDRESS_LINE_3: null | string;
  CITY: null | string;
  REGION_NM: null | string;
  REGION_CD: null | string;
  PO_BOX: null | string;
  POSTAL_CODE: null | string;
  COUNTRY_NAME: null | string;
  COUNTRY_ISO2: null | string;
  COUNTRY_ISO3: null | string;
  AD_MOBILITY_SCORE: null | string;
  AD_RESULT_PERCENTAGE: null | string;
  AD_MATCH_CODE: null | string;
  AD_ADDRESS_TYPE: null | string;
  USER_OVERRIDE_FLAG: null | string;
};

type wSuggestAddressesErrorType = {
  code?: string;
  hasQ0Failure?: boolean;
  message?: string;
};

export type GET_SUGGEST_ADDRESSES_TYPE = {
  wSuggestAddresses: {
    status?: string;
    errors?: wSuggestAddressesErrorType[];
    suggestedAddresses: wSuggestAddressesItemType[];
  };
};

export const GET_SUGGEST_ADDRESSES = gql`
  query wSuggestAddresses($address: Object) {
    wSuggestAddresses(address: $address)
  }
`;
